import { useQuery } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { createApiClient } from '../client';

export const usePurchaseOrder = (poNumber: string) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const apiClient = createApiClient(getAccessTokenSilently);

  return useQuery({
    queryKey: ['purchaseOrder', poNumber],
    queryFn: () => apiClient.getPurchaseOrder(poNumber),
    enabled: isAuthenticated && Boolean(poNumber)
  });
};
